import React, { useEffect } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router'
import { fetchUser, logout } from 'app/appSlice'
import { readSessionStorage } from 'common/utils/StorageUtil'
import useParseJson from 'common/hooks/useParseJson'
import { isNil } from 'lodash'
import { Buffer } from 'buffer'
import { URL_WANTED } from 'common/constants/Constants'

const setUrlWanted = () => {
    const pathToPush = document.location.pathname.substring(1)
    if (pathToPush && pathToPush !== 'login' && pathToPush !== 'home') {
        localStorage.setItem(URL_WANTED, pathToPush)
    }
}

const getTokenPayload = () => {
    const token = readSessionStorage('aquaparc-token')
    if (token) {
        return Buffer.from(token.split('.')[1], 'base64')
    }
    return ''
}

const AuthenticatedComponent = ({ Component, ...props }) => {
    const dispatch = useDispatch()
    const { user } = useSelector(store => ({ user: store.app.user }), shallowEqual)

    const tokenPayload = getTokenPayload()
    const { json: { exp } } = useParseJson(tokenPayload)

    useEffect(() => {
        if (!user && tokenPayload) {
            const login = readSessionStorage('aquaparc-login')
            if (login) {
                dispatch(fetchUser(login))
            }
        }
    }, [dispatch])

    if (!tokenPayload) {
        setUrlWanted()
        return <Navigate to='/login' />
    }
    if (moment().isAfter(moment(exp))) {
        setUrlWanted()
        dispatch(logout())
        return <Navigate to='/login' />
    }
    if (isNil(user)) return null
    return <Component {...props} />
}

AuthenticatedComponent.propTypes = {
    Component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
}

export default AuthenticatedComponent